<div class='app-loading'
     *ngIf='loadingService.loadingState$ | async'>
  <app-spinner></app-spinner>
</div>
